'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TaskFormView;

var _preact = require('preact');

var _reactRouterDom = require('react-router-dom');

var _client = require('../../client.js');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TaskFormView(props) {
  return (0, _preact.h)(
    'div',
    { 'class': 'form' },
    (0, _preact.h)(
      'div',
      null,
      props.content && (0, _preact.h)(
        'div',
        null,
        props.content.name
      ),
      (0, _preact.h)(
        'label',
        null,
        'content'
      ),
      (0, _preact.h)(
        'button',
        { onClick: props.clearContent },
        'x'
      )
    ),
    (0, _preact.h)(
      'div',
      null,
      props.style && (0, _preact.h)(
        'div',
        null,
        props.style.name
      ),
      (0, _preact.h)(
        'label',
        null,
        'style'
      ),
      (0, _preact.h)(
        'button',
        { onClick: props.clearStyle },
        'x'
      )
    ),
    (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)('input', { type: 'range', step: '0.001', min: '0.001', max: '1', value: props.alpha,
        onInput: function onInput(e) {
          return props.setAlpha(e.target.value);
        }
      }),
      'alpha: ',
      props.alpha
    ),
    (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'button',
        { onClick: props.createTask },
        'Create'
      )
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Tasks/TaskFormView.jsx
// module id = 110
// module chunks = 0